export function productSuiteSettingsFailedMessage() {
  return "Product Suite settings could not be updated. Check the connection and try again."
}

export function productSuiteSettingsLoadFailedMessage() {
  return "Product Suite settings could not be loaded. Check the connection and try again."
}

export function productSuiteToolsLoadFailedMessage() {
  return "Product Suite tools could not be loaded. Check manual access and try again."
}

export function serverSettingsRequestFailedMessage() {
  return "Server settings could not be updated. Check the connection and try again."
}

export function sessionHeaderActionFailedMessage() {
  return "Session action could not finish. Check app permissions and try again."
}

export function mcpServerConnectFailedMessage() {
  return "The MCP server could not connect. Check the server setup, then try again."
}

export function mcpActionFailedMessage() {
  return "MCP server settings could not be updated. Check the server setup and try again."
}

export function pluginRuntimeToggleFailedMessage() {
  return "Plugin setting could not be updated. Check the plugin connection and try again."
}

export function voiceTranscriptionFailedMessage() {
  return "Voice input could not be transcribed. Check the microphone recording and try again."
}

export function sessionGoalSaveFailedMessage() {
  return "Goal could not be saved. Check the session connection and try again."
}

export function archivedChatsLoadFailedMessage() {
  return "Archived chats could not be loaded. Check the connection and try again."
}

export function archivedChatRestoreFailedMessage() {
  return "Chat could not be restored. Check the connection and try again."
}

export function customProviderSaveFailedMessage() {
  return "Custom provider could not be saved. Check the provider details and try again."
}

export function sessionForkFailedMessage() {
  return "Session could not be forked. Check the connection and try again."
}

export function pluginInstallFailedMessage() {
  return "Plugin could not be installed. Check the plugin source and try again."
}

export function pluginRemoveFailedMessage() {
  return "Plugin could not be removed. Check the plugin setup and try again."
}

export function pluginToggleFailedMessage() {
  return "Plugin setting could not be updated. Check the plugin setup and try again."
}

export function pluginFileChooseFailedMessage() {
  return "Plugin file could not be selected. Try again or paste the plugin path manually."
}

export function pluginRestartUnavailableMessage() {
  return "Restart is unavailable from this window. Restart OpenAnalyst manually to finish installing plugins."
}

export function pluginRestartPrepareFailedMessage() {
  return "OpenAnalyst could not prepare the restart. Restart the app manually to finish installing plugins."
}

export function pluginRestartFailedMessage() {
  return "OpenAnalyst could not restart. Restart the app manually to finish installing plugins."
}

export function settingsUpdateCheckFailedMessage() {
  return "Update check could not finish. Check the connection and try again."
}

export function hooksSettingsSaveFailedMessage() {
  return "Hooks settings could not be saved. Check the JSON and try again."
}

export function integrationDisconnectFailedMessage() {
  return "Integration could not be disconnected. Check the connection and try again."
}

export function providerDisconnectFailedMessage() {
  return "Provider could not be disconnected. Check the connection and try again."
}

export function terminalConnectionFailedMessage() {
  return "Terminal connection was lost. Reopen the terminal and try again."
}

export function updateCheckFailedMessage() {
  return "Update check could not finish. Check the connection and try again."
}

export function fileTreeLoadFailedMessage() {
  return "File tree could not be loaded. Check the connection and try again."
}

export function fileLoadFailedMessage() {
  return "File could not be opened. Check that it still exists and try again."
}

export function firstRunStartFailedMessage() {
  return "First run could not start. Open the project chat and try again."
}

export function firstRunFollowupFailedMessage() {
  return "Message could not be sent. Check the connection and try again."
}

export function hostedProjectCreateFailedMessage() {
  return "Hosted project could not be created. Check the project files and try again."
}

export function diagnosticsOpenFailedMessage() {
  return "Diagnostics could not be opened. Check app permissions and try again."
}
